import { render } from "./RichTextMenu.vue?vue&type=template&id=870c5008&scoped=true"
import script from "./RichTextMenu.vue?vue&type=script&lang=js"
export * from "./RichTextMenu.vue?vue&type=script&lang=js"

import "./RichTextMenu.vue?vue&type=style&index=0&id=870c5008&lang=scss&scoped=true"
import "./RichTextMenu.vue?vue&type=style&index=1&id=870c5008&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-870c5008"]])

export default __exports__